module.exports = __webpack_public_path__ + "static/bg-mor-319f75a30018a0adc1a20495273b4894.webp";